import { useRef } from 'react';
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import PostHeader from 'src/modules/community/singlePost/components/postHeader';
import Responses from 'src/modules/community/singlePost/components/responses';
import NextPosts from 'src/modules/community/singlePost/components/nextPosts';
import GlobalSearch from 'src/modules/search/shared/components/searchBar';
import PostActions from 'src/modules/community/singlePost/components/postActions';
import WriteReplyBox from 'src/modules/community/singlePost/components/replies/writeReplyBox';
import Post from 'src/modules/community/singlePost/components/post';
import { textSmall, TitleMedium } from 'styles-js/mixins/typography';
import FeaturedPost from 'src/modules/community/shared/components/featuredPosts/featuredPost';
import Spacer from 'src/components/spacer';
import BlockedPost, { useIsPostBlocked } from 'src/modules/community/singlePost/components/blockedPost';
import SkipFeaturedPostsButton from 'src/modules/community/singlePost/components/skipFeaturedPostsButton';
import { useFetchFeaturedPosts } from 'src/utils/featuredPosts';
import { useIsLoggedIn } from 'src/utils/hooks/useIsLoggedIn';
export default function PostContent() {
  const [featuredPostTop, featuredPostBottom] = useFetchFeaturedPosts();
  const isLoggedIn = useIsLoggedIn();
  const post = useSelector(({
    pages
  }) => pages.singlePost.post);
  const isPostBlocked = useIsPostBlocked();
  const respondRef = useRef(null);
  const replyScrollRef = useRef<HTMLDivElement>(null);
  return <Container data-sentry-element="Container" data-sentry-component="PostContent" data-sentry-source-file="postContent.tsx">

      <PostHeader data-sentry-element="PostHeader" data-sentry-source-file="postContent.tsx" />

      {isPostBlocked ? <BlockedPost postEnrichedBody={post?.enriched?.body} /> : <>
            <Post />

            <PostActions replyScrollRef={replyScrollRef} respondRef={respondRef} />

            {featuredPostTop && <section>
                <FeaturedPostHeader>
                  <p>{i18n.t('Featured Content')}</p>
                  <SkipFeaturedPostsButton />
                </FeaturedPostHeader>
                <FeaturedPostContainer data-testid="featured-post-container-1">
                  <FeaturedPost featuredPost={featuredPostTop} key={featuredPostTop.featuredPostId} position="spp-top" />
                </FeaturedPostContainer>
              </section>}

            {isLoggedIn && <WriteReplyBox replyScrollRef={replyScrollRef} respondRef={respondRef} />}

            <Responses />

            {isLoggedIn && post.responses?.length >= 3 && <WriteReplyBox />}

            {featuredPostBottom && <section>
                <FeaturedPostHeader>
                  <p>{i18n.t('Featured Content')}</p>
                </FeaturedPostHeader>
                <FeaturedPostContainer data-testid="featured-post-container-2">
                  <FeaturedPost featuredPost={featuredPostBottom} key={featuredPostBottom.featuredPostId} position="spp-bottom" />
                </FeaturedPostContainer>
              </section>}
          </>}

      {!isLoggedIn && <section>
          <TitleMedium as="h2">{i18n.t(`Not what you're looking for?`)}</TitleMedium>
          <GlobalSearch dataTestId="search-page-bar" placeholder={i18n.t('Search our archives for advice and experiences')} />
        </section>}

      <Spacer data-sentry-element="Spacer" data-sentry-source-file="postContent.tsx" />

      <NextPosts data-sentry-element="NextPosts" data-sentry-source-file="postContent.tsx" />

    </Container>;
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    padding: 0 15px;
    margin-bottom: 40px;
    gap: 20px;
  }
`;
const FeaturedPostHeader = styled.div`
  ${textSmall}
  padding-bottom: 10px;
  color: ${({
  theme
}) => theme.colorTextLight};
  display: flex;
  justify-content: space-between;

  @media (${({
  theme
}) => theme.underScreenSmall}) {
    border-bottom: ${({
  theme
}) => theme.greyLine};
  }
`;
const FeaturedPostContainer = styled.div`
  padding: 25px;
  border: ${({
  theme
}) => theme.greyLine};
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    padding: 20px 0;
    border: none;
    border-bottom: ${({
  theme
}) => theme.greyLine};
  }
`;